import './FooterLegend.css';
const FooterLegend = () => {
  return (
    <div className='footerLegend-div'>
    <h2 className='footerLegend-legend'>Sé parte de la revolución educativa veterinaria global.</h2>
    <h3 className='footerLegend-secondLegend'>Sé parte de la comunidad FORVET.</h3>
    </div>
  )
}
export default FooterLegend